import withStyles from "@material-ui/core/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy } from "core";
import AlertHelper from "core/AlertHelper";
import PropTypes from "prop-types";
import React from "react";
import { OperationType } from "views/Constants/Constant";
import CommissionProfileDetailAddOrUpdate from "./CommissionProfileDetailAddOrUpdate";
import CommissionProfileDetailDataTable from "./CommissionProfileDetailDataTable";

const styles = theme => ({
	...sweetAlertStyle
});

const initialModel = {
	UseStandartRate: true,
	FirstMonthCommissionRate: 50,
	FollowingCommissionRate: 1
};

class CommissionFeeProfileDetail extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			list: [],
			model: initialModel,
			operationType: OperationType.DEFAULT
		};

		this.handleOperationType = this.handleOperationType.bind(this);

		this.handleGetList = this.handleGetList.bind(this);
		this.successListCallback = this.successListCallback.bind(this);
		this.errorListCallback = this.errorListCallback.bind(this);

		this.showSuccessMessage = this.showSuccessMessage.bind(this);
		this.showErrorMessage = this.showErrorMessage.bind(this);
		this.hideAlert = this.hideAlert.bind(this);
	}

	componentDidMount() {
		this.handleGetList();
	}

	handleOperationType(value, model = initialModel) {
		this.setState({ operationType: value, model });
	}

	handleGetList() {
		Proxy.GET(
			"/bankapi/v1.0/CustomerAgentCommission/GetAll",
			this.successListCallback,
			this.errorListCallback
		);
	}

	successListCallback(responseData) {
		if (!responseData.IsSucceeded) {
			this.showErrorMessage(responseData.ErrorDescription);
			return;
		}
		if (responseData.Item != null) {
			this.setState({ list: responseData.Item });
		}
	}

	errorListCallback(error) {
		this.showErrorMessage("An error occurred while requesting data. Error: " + error);
	}

	showSuccessMessage(message) {
		this.setState({
			alert: AlertHelper.CreateAlert("Success", message, "success", this.hideAlert)
		});
	}

	showErrorMessage(message) {
		this.setState({
			alert: AlertHelper.CreateAlert("Error", message, "error", this.hideAlert)
		});
	}

	hideAlert() {
		this.setState({ alert: null });
	}

	render() {
		const { operationType } = this.state;

		return (
			<div>
				<GridContainer spacing={16}>
					{this.state.alert}
					<GridItem md={12} xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GridContainer spacing={16}>
									<GridItem md={12} xs={12}>
										{operationType === OperationType.DEFAULT &&
											<CommissionProfileDetailDataTable
												list={this.state.list}
												handleGetList={this.handleGetList}
												handleOperationType={this.handleOperationType} />
										}
										{operationType !== OperationType.DEFAULT &&
											<CommissionProfileDetailAddOrUpdate
												model={this.state.model}
												handleGetList={this.handleGetList}
												handleOperationType={this.handleOperationType} />
										}
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

CommissionFeeProfileDetail.propTypes = {
	classes: PropTypes.object
};

export default withStyles(styles)(CommissionFeeProfileDetail);
